import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import "./css/materialize.css";
import "./css/style.css";

// import axios from 'axios';
import QRQinectAPI from '../QRQinectAPI';

class ContinueWith extends Component {
    constructor(props) {
        super(props);

        let headerText = "Reset Password";
        if (props.actionType === "create") {
            headerText = "Create Password";
        }
        this.state = {
            email: '',
            buyer: null,
            password1: "",
            password2: "",
            headerText: headerText,
            preHeaderText: ""
        }
    }
    componentDidMount() {
        QRQinectAPI.getBuyer(this.props.token)
        .then( (response) => {
            this.setState({ buyer: response.data, email: response.data.Email });
        })
        .catch( (error) => {
            let errorMessage = error.toString();
            if(error.response && error.response.data) {
                errorMessage = error.response.data;
            }
            this.setState({ ShowComponent: true, error: true, errorMessage: errorMessage });
        });
    }

    handleNameChange = (event) => {
        let name = event.target.value;
        this.setState({name: event.target.value, invalidName: !name });
    }
    handlePassword1Change = (event) => {
        let password = event.target.value;
        this.setState({password1: password, passwordsMustMatch: this.state.password2 !== password, passwordLength: password.length < 6 });
    }
    handlePassword2Change = (event) => {
        let password = event.target.value;
        this.setState({password2: password, passwordsMustMatch: this.state.password1 !== password });
    }
    continue = (type) => {
        if (this.state.password1 === "" || this.state.password2 === "") {
            return;
        }
        if (this.state.password1 !== this.state.password2) {
            return;
        }
        if (this.state.passwordLength) { // password isn't long enough
            return;
        }
        if (type === "create" ) {
            QRQinectAPI.createBuyerPassword(this.props.token, this.state.buyer.ID, this.state.password1)
            .then( (response) => {
                this.setState({ showMessageDialog: true, message: "Woohoo! Your password has been created!"});
            })
            .catch( (error) => {
                console.log(error);
                let errorMessage = error.toString();
                if(error.response && error.response.data) {
                    errorMessage = error.response.data;
                }
                this.setState({ error: true, errorMessage: errorMessage });
            });
        } else if (type === "update") {
            QRQinectAPI.updateBuyerPassword(this.props.token, this.state.buyer.ID, this.state.password1)
            .then( (response) => {
                console.log(response);
                this.setState({ showMessageDialog: true, message: "Woohoo! Your password has been updated!"});
            })
            .catch( (error) => {
                console.log(error);
                let errorMessage = error.toString();
                if(error.response && error.response.data) {
                    errorMessage = error.response.data;
                }
                this.setState({ error: true, errorMessage: errorMessage });
            });
        }
    }
    renderError() {
        if (this.state.error) {
            return (
                <div style={{ textAlign: 'center', color: 'red' }}>{this.state.errorMessage}</div>
            );
        } else {
            return null;
        }
    }
    renderOptions() {
        return (
            <form action="#">
                <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <div style={{ textAlign: 'center', marin: '0 auto' }} className="secondaryColor">{this.state.preHeaderText}</div>
                    <div style={{ textAlign: 'center', marin: '0 auto', fontSize: '30px', marginBottom: '10px' }} className="header">{this.state.headerText}</div>
                    <div style={{ textAlign: 'center', marin: '0 auto' }}>{this.state.descriptionTextLine1}</div>
                    <div style={{ textAlign: 'center', marin: '0 auto' }}>{this.state.descriptionTextLine2}</div>
                </div>
                <p>{this.state.emailHeader}</p>
                {this.renderCreatePassword()}
            </form>
        );
    }
    renderCreatePassword() {
        if (this.props.actionType === "create") {
            return (
                <React.Fragment>
                        <div className="input-field">
                            <input readOnly id="email" type="email" className="validate" value={this.state.email} />
                            <label htmlFor="email">Email</label>
                        </div>
                        <div className="input-field">
                            <input id="password1" type="password" className="validate" value={this.state.password1} onChange={event => this.handlePassword1Change(event)} />
                            <label htmlFor="password1">Password</label>
                        </div>
                        <div className="input-field">
                            <input id="password2" type="password" className="validate" value={this.state.password2} onChange={event => this.handlePassword2Change(event)} />
                            <label htmlFor="password2">Re-enter Password</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.passwordsMustMatch ? 'Passwords must match' : ''}</div>
                        <div style={{ color: 'red' }}>{this.state.passwordLength ? 'Password must be at least 6 characters long' : ''}</div>
                        <div>
                            <a className="button" onClick={() => this.continue('create')}>CONTINUE</a>
                        </div>

                </React.Fragment>
            );
        } else if (this.props.actionType === "update") {
            return (
                <React.Fragment>
                        <div className="input-field">
                            <input readOnly id="email" type="email" className="validate" value={this.state.email} />
                            <label htmlFor="email">Email</label>
                        </div>
                        <div className="input-field">
                            <input id="password1" type="password" className="validate" value={this.state.password1} onChange={event => this.handlePassword1Change(event)} />
                            <label htmlFor="password1">Password</label>
                        </div>
                        <div className="input-field">
                            <input id="password2" type="password" className="validate" value={this.state.password2} onChange={event => this.handlePassword2Change(event)} />
                            <label htmlFor="password2">Re-enter Password</label>
                        </div>
                        <div style={{ color: 'red' }}>{this.state.passwordsMustMatch ? 'Passwords must match' : ''}</div>
                        <div style={{ color: 'red' }}>{this.state.passwordLength ? 'Password must be at least 6 characters long' : ''}</div>
                        <div>
                            <a className="button" onClick={() => this.continue('update')}>CONTINUE</a>
                        </div>
                </React.Fragment>
            );
        }
        return null;
    }
    renderErrorModal() {
        if (this.state.error) {
            return (
                <React.Fragment>
                    <div onClick={() => {this.setState({error: false})}} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px' }}>
                        <div style={{color: 'red'}}>
                                {this.state.errorMessage}
                        </div>
                        <div>
                            <a className="button" onClick={() => {this.setState({error: false})}} style={{ display: 'inline-block', backgroundColor: '#666' }}>CLOSE</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderMessageModal() {
        if (this.state.showMessageDialog) {
            return (
                <React.Fragment>
                    <div onClick={this.reload} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px' }}>
                        <div>
                            {this.state.message}
                        </div>
                        <div>
                            Scan your card again to add your video or
                        </div>
                        <div>
                            <Link to={'/report/' + this.props.token}>
                                <div className="button" onClick={this.reload} style={{ display: 'inline-block' }}>GO TO MY ACCOUNT</div>
                            </Link>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div ref="videoContainer" className="head">
                                <div className="logoImage"></div>

                                {this.renderOptions()}
                                <div style={{ textAlign: 'center' }}>
                                </div>
                            </div>
                            {this.renderErrorModal()}
                            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                By continuing you agree to the <a href="/terms" target="_blank" >terms & conditions</a> & <a href="/privacy" target="_blank">privacy policy</a>.
                            </div>
                            {this.renderMessageModal()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(ContinueWith);



// WEBPACK FOOTER //
// ./src/components/AccountPassword.js